import angular from 'angular';
import { SuffixSelectComponent } from './suffix-select.component';

export const SuffixSelectModule = angular
  .module('upd.suffix-select', [])
  .component('updSuffixSelect', SuffixSelectComponent);
